<template>
	<Modal :visible="visible" :class="{'is-ca': $activeUser && $activeUser.profile.country !== 'USA' }" class="availability-settings-modal" @toggle="$emit('toggle', !!$event)">
		<template #title>Default Rolling Availability Settings</template>
		<template #content>
			<AvailabilitySettings @close="$emit('toggle', !!$event)"/>
		</template>
	</Modal>
</template>
  
<script>
import AvailabilitySettings from '@/components/availability/AvailabilitySettings';

export default {
	name: 'AvailabilitySettingsModal',
	components: {
		AvailabilitySettings,
	},
	model: {
		prop: 'visible',
		event: 'toggle',
	},
	props: {
		visible: {
			type: Boolean,
			default: null,
		},
	},
	data() {
		return {
			showModal: true,
		};
	},
};
</script>
